import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Icon,
    Typography,
} from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import SelectInput from '../../Common/SelectInput'
import { fetchEntityRecordsListBySearch } from '../../../services/entityServices'
import theme from '../../../theme/theme'
import SearchInput from '../../Common/SearchInput'
import { useTranslation } from 'react-i18next'

interface RelationModificationType {
    orgId: string
    parentTemplateId: string
    selectedItemTemplateId: string
    isOpen: boolean
    onClose: any
    onSubmit: any
}

const RelationModification = ({
    orgId,
    parentTemplateId,
    selectedItemTemplateId,
    isOpen,
    onClose,
    onSubmit,
}: RelationModificationType): ReactElement => {
    const { t } = useTranslation()
    const statusList = [
        { id: 'REPLACED', name: t('replace') },
        { id: 'TERMINATED', name: t('terminate') },
    ]
    const [status, setStatus] = useState('')

    const [relationRecordsList, setRelationRecordsList] = useState([])
    const [replacedItem, setReplacedItem] = useState<any>(null)

    const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(true)

    const onChangeStatus = (id: string, value: string) => {
        setStatus(value)
    }

    const onSearchRelationRecords = async (id: string, value: string) => {
        const templateID = selectedItemTemplateId
        const parentTemplateID = parentTemplateId
        const searchText = value

        const relationEntityRecords = await fetchEntityRecordsListBySearch(
            orgId,
            templateID,
            parentTemplateID,
            searchText,
        )
        setRelationRecordsList(relationEntityRecords)
    }

    const onSelectRelationRecord = (obj: any) => {
        setReplacedItem(obj)
    }

    const onClickRemoveSelectedItemOnReplace = () => {
        setReplacedItem(null)
    }

    const getFilterSearchList = () => {
        let updatedRelationRecordsList: any = relationRecordsList || []
        if (replacedItem) {
            updatedRelationRecordsList = relationRecordsList?.filter(
                (i: any) => i.entityId !== replacedItem?.entityId,
            )
        }
        return updatedRelationRecordsList
    }

    const onSubmitDailog = () => {
        onSubmit(status, replacedItem)
        setTimeout(() => {
            onCloseDialog()
        }, 500)
    }

    const onCloseDialog = () => {
        setRelationRecordsList([])
        setReplacedItem(null)
        setStatus('')
        onClose()
    }

    useEffect(() => {
        if (selectedItemTemplateId) {
            onSearchRelationRecords('', '')
        }
    }, [selectedItemTemplateId])

    useEffect(() => {
        setReplacedItem(null)
    }, [status])

    useEffect(() => {
        if (status === 'REPLACED' && replacedItem) {
            setIsSubmitDisable(false)
        } else if (status === 'TERMINATED') {
            setIsSubmitDisable(false)
        } else {
            setIsSubmitDisable(true)
        }
    }, [status, replacedItem])

    return (
        <Dialog
            open={isOpen}
            scroll="paper"
            PaperProps={{
                sx: {
                    width: '400px',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ padding: '10px 30px' }}
            onClose={() => onCloseDialog()}
        >
            <Box>
                <DialogTitle id="scroll-dialog-title" sx={{ padding: '0px' }}>
                    <Box
                        display="flex"
                        alignItems="center"
                        padding="15px"
                        paddingLeft="20px"
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ paddingTop: '10px' }}
                        >
                            {t('updateRelation')}
                        </Typography>
                        <Icon
                            onClick={() => onCloseDialog()}
                            sx={{ marginLeft: 'auto' }}
                            fontSize="small"
                            id="relation-update-close-icon"
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Box sx={{ width: 'calc(100%)' }}>
                            <SelectInput
                                label=""
                                id="relation_status"
                                value={status}
                                onChange={onChangeStatus}
                                list={statusList}
                                hasEmpty={false}
                                //    errorMessage={''}
                            />
                        </Box>
                        {status === 'REPLACED' ? (
                            <Box
                                sx={{
                                    width: '100%',
                                    marginTop: '30px',
                                    height: '130px',
                                }}
                                display="flex"
                                flexDirection="column"
                            >
                                {/* <Box>
                                        <Typography>Search</Typography>
                                    </Box> */}
                                <Box>
                                    <SearchInput
                                        id="SearchSelectInput-relation-status-details"
                                        label=""
                                        value=""
                                        onChange={(id: string, value: string) =>
                                            onSearchRelationRecords(id, value)
                                        }
                                        onSelect={(obj: any) =>
                                            onSelectRelationRecord(obj)
                                        }
                                        searchedList={
                                            getFilterSearchList() || []
                                        }
                                        list_Height="150px"
                                    />
                                </Box>
                                {replacedItem ? (
                                    <Box sx={{ marginTop: '20px' }}>
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontWeight: '600',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {t('replaceWith')}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background:
                                                        theme.palette.primary
                                                            .main,
                                                    padding: '10px',
                                                    marginRight: '10px',
                                                    borderRadius: '5px',
                                                    marginTop: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        cursor: 'pointer',
                                                        width: 'auto',
                                                        height: 'auto',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: '14px',
                                                            color: '#FFF',
                                                        }}
                                                    >
                                                        {
                                                            replacedItem?.displayName
                                                        }
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent:
                                                            'center',
                                                        alignItems: 'center',
                                                        marginLeft: '6px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() =>
                                                        onClickRemoveSelectedItemOnReplace()
                                                    }
                                                    id="relation-status-remove-button"
                                                >
                                                    {' '}
                                                    <CloseOutlined
                                                        sx={{
                                                            color: '#FFF',
                                                            fontSize: '20px',
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                ) : (
                                    <></>
                                )}
                            </Box>
                        ) : (
                            <></>
                        )}
                        <Box
                            onClick={
                                isSubmitDisable
                                    ? () => {}
                                    : () => onSubmitDailog()
                            }
                        >
                            <Button
                                sx={{
                                    mt: 4,
                                }}
                                variant="contained"
                                fullWidth
                                id="relation-status-submit-button"
                                disabled={isSubmitDisable}
                            >
                                {t('submit')}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default RelationModification
